module.exports = {"360922001":"康乐街道","360922100":"株潭镇","360922101":"黄茅镇","360922102":"潭埠镇","360922103":"双桥镇","360922104":"高村镇","360922105":"罗城镇","360922106":"三兴镇","360922107":"高城镇","360922108":"白良镇","360922200":"鹅峰乡","360922201":"马步乡","360922203":"赤兴乡","360922204":"岭东乡","360922205":"白水乡","360922206":"仙源乡","360922208":"茭湖乡","360922400":"万载县工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360922.json
// module id = 1433
// module chunks = 0